import _ from 'lodash';
import React from 'react';

import { useRootActivityLazyQuery } from 'generated/graphql';
import { authService } from 'iron-forge-react-modules';



export interface IData {
  isSuperAdmin: boolean;
  storeIds: string[];
  permissions: string[];
}

export function useQuery(authState: authService.IAuthState) {
  const [fnQuery, queryTuple] = useRootActivityLazyQuery();



  React.useEffect(
    () => {
      if (authState.status === 'loggedIn') {
        fnQuery({});
      }
    },
    [authState.status, fnQuery]
  );



  const wrappedTuple = React.useMemo(
    () => {
      const data: IData = {
        isSuperAdmin: queryTuple.data?.loggedInUser?.isSuperAdmin ?? false,
        storeIds: _.map(queryTuple.data?.stores.nodes ?? [], store => store.id),
        permissions: _.map(queryTuple.data?.loggedInUser?.permissions ?? [], permission => permission.name)
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]);



  return wrappedTuple;
}
